import { useLocalization } from "@fluent/react";
import { Button } from "@narmi/design_system";
import { PromoFluentIds } from "byzantine/src/l10n/SettingFluentIds";
import utils from "byzantine/src/utils";
import cc from "classcat";

import styles from "./SidebarPromotionCard.module.scss";

import type { PromotionCardProps } from "../../../../components/dashboard/PromotionCard/types";

const SidebarPromotionCard = ({ promotion }: PromotionCardProps) => {
  const { l10n } = useLocalization();
  const promoIndex = promotion.promo_index || 0;

  const fluentIds = new PromoFluentIds(promoIndex);
  const translatedPromotion = {
    title: l10n.getString(fluentIds.getTitle(), null, promotion.title),
    description: l10n.getString(
      fluentIds.getDescription(),
      null,
      promotion.description
    ),
    action_text: l10n.getString(
      fluentIds.getActionText(),
      null,
      promotion.action_text || "Learn more"
    ),
  };

  return (
    <div className={styles["promotion-card"]} data-testid="promotion-item">
      <div className={styles["promotion-card-title"]}>
        <span
          className={cc([
            utils.ndsIconPrepend(promotion.icon),
            styles["promotion-card-icon"],
          ])}
        />
        <div>{translatedPromotion.title}</div>
      </div>
      {translatedPromotion.description}
      <Button
        as="a"
        href={promotion.url}
        kind="plain"
        ariaLabel={`${translatedPromotion.title} - ${translatedPromotion.action_text}`}
        label={translatedPromotion.action_text}
        testId="promotion-action"
        rel="noreferrer"
        target="_blank"
      />
    </div>
  );
};

export default SidebarPromotionCard;
